import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ComicListView from '@/components/disposable/ComicListView.vue';
import { ComicType } from '@/model/comic';

export default /*#__PURE__*/_defineComponent({
  __name: 'MangaView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComicListView, {
    type: _unref(ComicType).Manga
  }, null, 8, ["type"]))
}
}

})